<div class="div_venue d-flex">
</div>
